// AuthHubListener.tsx
import { Hub } from "aws-amplify/utils";
import { useEffect } from "react";
import { useNavigate } from "react-router";

export function AuthHubListener() {
  const navigate = useNavigate();

  useEffect(() => {
    const listener = (hubPayload: any) => {
      const { event, data } = hubPayload.payload;

      if (event === "customOAuthState") {
        console.log("OauthRedirect");
        if (data === "/login") navigate("/dashboard");
        if (data === "/buypanels/signup") navigate("/buypanels/signup");
      }
    };

    const unsubscribe = Hub.listen("auth", listener);
    return unsubscribe;
  }, []);

  return null;
}
